<template>
  <Page>
    <template #extra-content>
      <QuickList />
    </template>
  </Page>

  <ErrorPageModal :error />
</template>

<script setup lang="ts">
import Page from "@/components/page/Page.vue";
import ErrorPageModal from "@/components/ErrorPageModal.vue";

import { QuickList } from "@/components/home";

defineProps<{ error?: number | boolean }>();
</script>
